// src/routes/PrivateRoute.tsx
import { Navigate, useLocation } from 'react-router';
import { useAppSelector } from '@/core/store/hooks';

export const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const { isAuthenticated, token } = useAppSelector(state => state.auth);
  
  // Check both isAuthenticated flag and token existence
  const isValidAuth = isAuthenticated && !!token;

  if (!isValidAuth) {
    // Preserve the attempted route for redirect after login
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
};